import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';

import { DataAccessUserFacade } from '../state/user/data-access-user.facade';

@Injectable({
  providedIn: 'root',
})
/**
 * This guard redirects all authenticated users to the profile completion if the profile is not complete.
 * Unauthenticated users are not redirected.
 */
export class ProfileCompletedGuard extends KeycloakAuthGuard {
  constructor(
    protected override readonly router: Router,
    protected readonly keycloak: KeycloakService,
    private userFacade: DataAccessUserFacade
  ) {
    super(router, keycloak);
  }

  public async isAccessAllowed(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authenticated) {
      return firstValueFrom(
        this.userFacade.profileCompleted$.pipe(
          map((profileCompleted) => {
            if (profileCompleted) {
              return true;
            } else {
              return this.router.parseUrl(`/profilecompletion?redirectUrl=${state.url}&mode=initial`);
            }
          })
        )
      );
    } else {
      return true;
    }
  }
}
